import { useProductCreateStore } from './useProductCreateStore';

export const customModalsConfig = [
  {
    key: 'createProduct',
    import: () => import('../views/CreateProduct'),
    store: useProductCreateStore,  // <-- Pass the function directly!
  },
];